module.exports = __webpack_public_path__ + "img/2-black.057f7be4.png";